import React, { Component } from 'react'
import { StatusAlertService } from 'react-status-alert'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import CacheManager from '../../../cache/CacheManager'
import CacheKeys from '../../../cache/CacheKeys'
import MessageUpdateUI from './MessageUpdateUI'

class MessageUpdateSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // update
      editMode: false,
      html: this.props.message.message,
      updateSubmitted: false,
      userIdList: [],
      // delete
      deleteMode: false,
      deleteSubmitted: false
    }
  }

  render() {
    return (
      <MessageUpdateUI
        context={this.props.context}
        messageList={this.props.messageList}
        project={this.props.project}
        message={this.props.message}
        projectUserMap={this.props.projectUserMap}
        // update
        editMode={this.state.editMode}
        onEditClick={this.onEditClick}
        onUpdateSubmit={this.onUpdateSubmit}
        updateSubmitted={this.state.updateSubmitted}
        onUpdateCancel={this.onUpdateCancel}
        // html for update
        html={this.state.html}
        onHtmlChange={this.onHtmlChange}
        // user list for update
        userIdList={this.state.userIdList}
        onUsersChange={this.onUsersChange}
        projectUserList={this.props.projectUserList}
        // delete
        deleteMode={this.state.deleteMode}
        onDeleteClick={this.onDeleteClick}
        onDeleteSubmit={this.onDeleteSubmit}
        onDeleteCancel={this.onDeleteCancel}
        deleteSubmitted={this.state.deleteSubmitted}
        //
        onForceTaskMessageListRefresh={this.props.onForceTaskMessageListRefresh}
      />
    )
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (props.task && props.task.taskId !== this.taskId) {
      this.taskId = props.task.taskId
      this.setState({updateSubmitted: false})
    }
  }

  // update -----------------------------------
  onEditClick = (event) => {
    this.setState({
      editMode: true,
      deleteMode: false
    })
  }

  onHtmlChange = (html) => {
    this.setState({html: html})
  }

  onUsersChange = (userIdList) => {
    this.setState({userIdList: userIdList})
  }

  onUpdateSubmit = () => {
    if (this.props.message.message === this.state.html) {
      console.log('unchanged')
      return
    }

    this.setState({updateSubmitted: true})
    RestApiUtils.put(this.props.context,
      `/api/tasks/${this.props.task.taskId}/messages/${this.props.message.dateCreatedCreatedBy}`,
      this.updateMessageCallback, {
        message: this.state.html,
        userIdList: this.state.userIdList
      }
    )
  }

  updateMessageCallback = response => {
    this.setState({updateSubmitted: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    let taskMessageList = this.props.taskMessageList
    let index = taskMessageList.findIndex(message => message.dateCreatedCreatedBy === response.taskMessage.dateCreatedCreatedBy)
    if (index >= 0) {
      taskMessageList[index] = response.taskMessage
    }

    this.setState({html: response.taskMessage.message, editMode: false})
    this.props.onMessageListUpdate(taskMessageList)

    CacheManager.removeObject(CacheKeys.TaskMessages(this.props.task.taskId))
  }

  handleError(errorList) {
    errorList.forEach(error => {
      if (error.errorCode === 'NotFound') {
        switch (error.objectCode) {
          case 'Task':
            this.props.onForceTaskListRefresh(this.props.task.projectId)
            break
          case 'TaskMessage':
            this.props.onForceTaskMessageListRefresh(this.props.task.taskId)
            break;
          default:
        }
      }
    })
    StatusAlertService.showError(errorList[0].message, {withCloseIcon: false})
  }

  onUpdateCancel = (event) => {
    this.setState({editMode: false, html: this.props.message.message})
  }

  // delete -----------------------------------
  onDeleteClick = (event) => {
    this.setState({
      editMode: false,
      deleteMode: true
    })
  }

  onDeleteSubmit = (event) => {
    this.setState({deleteSubmitted: true})
    RestApiUtils.delete(this.props.context,
      `/api/tasks/${this.props.task.taskId}/messages/${this.props.message.dateCreatedCreatedBy}`,
      this.deleteCallback, {}
    )
  }

  deleteCallback = response => {
    this.setState({deleteSubmitted: false})

    if (response.errorList.length > 0) {
      this.handleError(response.errorList)
      return
    }

    let taskMessageList = this.props.taskMessageList
    let index = taskMessageList.findIndex(message => message.dateCreatedCreatedBy === response.taskMessage.dateCreatedCreatedBy)
    if (index >= 0) {
      taskMessageList.splice(index, 1)
    }

    this.setState({deleteMode: false})
    this.props.onMessageListUpdate(taskMessageList)

    CacheManager.removeObject(CacheKeys.TaskMessages(this.props.task.taskId))
  }

  onDeleteCancel = (event) => {
    this.setState({deleteMode: false})
  }

}

export default MessageUpdateSF
